import Message from './message.vue'
import Vue from 'vue'

const defaultProps = {
  content: '',
  duration: '3'
}

function notice(props) {
  const Instance = new Vue({
    data: props,
    render(h) {
      return h(Message, {
        props
      })
    }
  })

  const component = Instance.$mount()
  document.body.appendChild(component.$el)

  setTimeout(() => {
    document.body.removeChild(component.$el)
    props.onClose && props.onClose()
  }, 1000 * props.duration)
}

export default {
  info(props) {
    props.type = 'info'
    return notice(Object.assign({}, defaultProps, props))
  },
  warning(props) {
    props.type = 'warning'
    return notice(Object.assign({}, defaultProps, props))
  },
  success(props) {
    props.type = 'success'
    return notice(Object.assign({}, defaultProps, props))
  },
  error(props) {
    props.type = 'error'
    return notice(Object.assign({}, defaultProps, props))
  }
}



// WEBPACK FOOTER //
// ./src/components/Message/index.js